export function parseProductPrice(value) {
  if (value == null || value === '') return 0;
  const cleaned = String(value).replace(/[^\d.-]/g, '');
  const num = Number(cleaned);
  return Number.isFinite(num) ? num : 0;
}

export function formatPrice(value) {
  const num = typeof value === 'number' ? value : parseProductPrice(value);
  return num.toLocaleString();
}

export function formatProductPrice(product) {
  const price = product?.price;
  if (price == null || price === '') return '';
  return formatPrice(price);
}

export function formatProductOriginalPrice(product) {
  const original = product?.originalPrice;
  if (original == null || original === '') return '';
  return formatPrice(original);
}

export function lineTotal(price, quantity) {
  return parseProductPrice(price) * quantity;
}

export function saleUnitPrice(product) {
  return parseProductPrice(product?.price);
}

export function originalUnitPrice(product) {
  if (product?.originalPrice) return parseProductPrice(product.originalPrice);
  return saleUnitPrice(product);
}

export function hasProductDiscount(product) {
  if (isProductPriceHidden(product)) return false;
  return (
    Boolean(product?.originalPrice) ||
    (product?.discountPercent != null && product.discountPercent > 0)
  );
}

export function hasProductPrice(product) {
  if (isProductPriceHidden(product)) return false;
  return saleUnitPrice(product) > 0;
}

export function isProductPriceHidden(product) {
  if (product == null) return false;
  if (typeof product.hidePrice === 'boolean') return product.hidePrice;
  const raw = product.hide_price ?? product.hidePrice;
  if (raw == null) return false;
  if (typeof raw === 'boolean') return raw;
  return Number(raw) === 1 || String(raw).toLowerCase() === 'true';
}
